import { render, staticRenderFns } from "./lancamentos.vue?vue&type=template&id=2c066e0a&"
import script from "./lancamentos.vue?vue&type=script&lang=js&"
export * from "./lancamentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports